import { registerFigure } from "./base.js";
/**
 * Stages arranged in a ring, with the flow running round it.
 *
 * The shape carries the idea on its own: a child who sees a ring understands
 * "and then it starts again" without being told, which is the part a paragraph
 * about the water cycle usually fails to land.
 */
export const cycleFigure = registerFigure({
    kind: "cycle",
    summary: "Stages in a ring, flowing back to the start.",
    chooseWhen: "The idea repeats — water cycle, seasons, day and night, life cycles. Only " +
        "pick it if the last stage really does lead back to the first. A process " +
        'that simply ends is not a cycle; use "parts" or no figure.',
    issues(figure) {
        const labels = figure.labels ?? [];
        if (labels.length < 3)
            return ["A cycle needs at least three stages to read as a ring."];
        // The shared shape allows twelve so `contrast` can fill a grid. A ring or a
        // stack of twelve is unreadable, so this kind holds its own line.
        if (labels.length > 5)
            return ["More than 5 stages stops being a picture."];
        if (labels.some((l) => l.trim().length === 0))
            return ["A cycle stage cannot be blank."];
        return [];
    },
    normalise(figure) {
        return {
            kind: "cycle",
            caption: figure.caption,
            labels: (figure.labels ?? []).map((l) => l.trim()),
        };
    },
    example: {
        kind: "cycle",
        caption: "The water never runs out — it goes round.",
        labels: ["Sun heats the sea", "Water rises as vapour", "Clouds form", "Rain falls"],
    },
});
//# sourceMappingURL=cycle.js.map